import React from 'react';

interface Milestone {
    quarter: string;
    title: string;
    description: string;
    status: 'completed' | 'active' | 'upcoming';
}

interface RoadmapTimelineProps {
    milestones: Milestone[];
    className?: string;
}

export const RoadmapTimeline: React.FC<RoadmapTimelineProps> = ({
    milestones,
    className = '',
}) => {
    return (
        <div className={`ecosystem-roadmap ${className}`}>
            {milestones.map((milestone, index) => (
                <div key={index} className={`ecosystem-milestone ${milestone.status}`}>
                    <div className="ecosystem-milestone-quarter">{milestone.quarter}</div>
                    <h3 className="ecosystem-milestone-title">{milestone.title}</h3>
                    <p className="ecosystem-milestone-desc">{milestone.description}</p>
                </div>
            ))}
        </div>
    );
};

export default RoadmapTimeline;
